var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSiteMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_248_1219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.4525 0V118.622H110.553V0H90.4525Z",
    fill: "url(#paint0_linear_248_1219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.603 41.8112C144.024 50.1265 160.804 72.563 160.804 98.9365L120.603 98.937V41.8112Z",
    fill: "url(#paint1_linear_248_1219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.402 41.8114C56.981 50.1265 40.201 72.563 40.201 98.9365C40.201 125.31 56.981 147.746 80.402 156.061V41.8114Z",
    fill: "url(#paint2_linear_248_1219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.3365 25.8738C48.5439 34.7341 25.1995 64.1135 25.1995 98.9915C25.1995 140.883 58.877 174.843 100.421 174.843C127.448 174.843 151.145 160.469 164.406 138.889H128.538V118.688L198.932 118.688C189.823 165.045 149.18 200 100.421 200C44.9598 200 0 154.777 0 98.9915C0 50.1245 34.4996 9.3624 80.3365 0.00354121V25.8738Z",
    fill: "url(#paint3_linear_248_1219)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.518 85.861C169.508 56.9075 148.215 33.5965 120.505 25.8738V0.00354409C162.167 8.51015 194.464 42.9611 200 85.861H174.518Z",
    fill: "url(#paint4_linear_248_1219)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_248_1219",
    x: 0,
    y: 0,
    width: 200,
    height: 203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_248_1219"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_1219",
    x1: 113.265,
    y1: 202.015,
    x2: 113.265,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_248_1219",
    x1: 113.265,
    y1: 202.015,
    x2: 113.265,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_248_1219",
    x1: 113.265,
    y1: 202.015,
    x2: 113.265,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_248_1219",
    x1: 113.265,
    y1: 202.015,
    x2: 113.265,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_248_1219",
    x1: 113.265,
    y1: 202.015,
    x2: 113.265,
    y2: -0.0259999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.65
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSiteMini);
export default __webpack_public_path__ + "static/media/logo-site-mini.524408db77efafb3ce47b6ac4cd7a881.svg";
export { ForwardRef as ReactComponent };